(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[851],{

/***/ 6248:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esg-guide/post/[id]",
      function () {
        return __webpack_require__(76335);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_esg_guide_post_Esg_guide_post__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18005);


var PostId = function(param) {
    var initialPostData = param.initialPostData, postId = param.postId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_esg_guide_post_Esg_guide_post__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            initialPostData: initialPostData,
            postId: postId
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PostId);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,8482,9807,8005,9774,2888,179], function() { return __webpack_exec__(6248); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);